import recipients from "@/store/app/dropbox/settings/recipients"

export default {
  namespaced: true,

  actions: {},

  modules: {
    recipients,
  }
}
